import ExcelJS from "exceljs";

/**
 * @method validateExcel
 * This function will validate the excel file based on the headers provided.
 */
export function validateExcel(file, excelHeaders, calllback) {
  var reader = new FileReader();
  reader.onloadend = function (event) {
    var arrayBuffer = reader.result;

    var workbook = new ExcelJS.Workbook();
    workbook.xlsx.load(arrayBuffer).then(async function (workbook) {
      const headerRow =
        workbook.worksheets && workbook.worksheets.length > 2
          ? workbook.worksheets[2].findRow(2)
          : [];
      const templateHeaders = headerRow.values;
      let response = {};

      if (headerRow.cellCount !== excelHeaders.length) {
        response = {
          status: "Error",
          message:
            "The uploaded file is not as per the standard template. Please refer the template file.",
        };

        return calllback(response);
      }

      const arraysDiff = excelHeaders.filter(
        (x) => !templateHeaders.includes(x),
      );

      if (arraysDiff.length > 0) {
        response = {
          status: "Error",
          message:
            "The column headers in the excel file do not match the column headers in the template.",
        };
        return calllback(response);
      }

      if (
        arraysDiff.length === 0 &&
        headerRow.cellCount === excelHeaders.length
      ) {
        response = {
          status: "Success",
          message: "",
        };
      }

      calllback(response);
    });
  };
  reader.readAsArrayBuffer(file);
}

/**
 * @method createExcelFile
 * This function will create an excel file from the data provided.
 * Returns a Blob that can be downloaded.
 */
export async function createExcelFile(sheets) {
  if (!sheets || sheets.length === 0) {
    console.warn("createExcelFile: No sheets provided");
    return null;
  }

  try {
    const workbook = new ExcelJS.Workbook();
    let hasWorksheetData = false;

    for (let i = 0; i < sheets.length; i++) {
      const sheet = sheets[i];

      if (!sheet.data || sheet.data.length === 0) {
        continue;
      }

      const columnKeys = sheet.data.reduce((keys, row) => {
        Object.keys(row || {}).forEach((key) => {
          if (!keys.includes(key)) {
            keys.push(key);
          }
        });
        return keys;
      }, []);

      if (columnKeys.length === 0) {
        continue;
      }

      const worksheet = workbook.addWorksheet(sheet.name);
      hasWorksheetData = true;

      worksheet.columns = columnKeys.map((header) => ({
        header: header.replace("zvalueToReplace", ""),
        key: header,
        width: 20,
      }));

      worksheet.getRow(1).font = {
        size: 12,
        bold: true,
      };

      sheet.data.forEach((d) => {
        const normalizedRow = columnKeys.reduce((row, key) => {
          row[key] = d?.[key] ?? "";
          return row;
        }, {});
        worksheet.addRow(normalizedRow);
      });
    }

    if (!hasWorksheetData) {
      console.warn("createExcelFile: No worksheet data found");
      return null;
    }

    //console.log("Writing Excel buffer...");
    const buffer = await workbook.xlsx.writeBuffer();
    //console.log("Excel buffer created, byteLength:", buffer.byteLength);

    // Create Blob with proper MIME type
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    //console.log("Blob created successfully, size:", blob.size);

    return blob;
  } catch (error) {
    console.error("createExcelFile error:", error);
    console.error("Error stack:", error?.stack);
    return null;
  }
}
